import TypePromo from '../TypePromo';

const PromoType = ({ productType }) => {
  if (!productType) return <TypePromo.DEAL />;
  const { campaignName, campaignType, shortName } = productType;
  const displayName = campaignName?.toLowerCase().includes('thuốc tốt - giá sỉ');
  switch (campaignType) {
    case 'FLASH_SALE':
      return <TypePromo.ThunderTitle />;
    case 'NORMAL':
      if (displayName) {
        return <TypePromo.SpecialChar />;
      }
      return shortName || campaignName;
    default:
      return displayName || null;
  }
};

export default PromoType;
